/* eslint-disable react/jsx-no-useless-fragment */
import { PopoverTrigger } from "@radix-ui/react-popover";
import classNames from "components/ui/classNames";
import { Popover, PopoverContent } from "components/ui/Popover";
import type { ReactNode } from "react";

interface IBookkeeperProps {
  bookkeeper: string;
  className?: string;
  side?: "top" | "right" | "bottom" | "left";
}

interface BookkeeperPopoverProps {
  bookkeeper: string;
  className?: string;
  side?: "top" | "right" | "bottom" | "left";
  children: ReactNode;
}

function BookkeeperPopover({ bookkeeper, className, side, children }: BookkeeperPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger
        className={classNames(
          "bg-transparent font-bold text-brand no-underline hover:underline hover:opacity-90",
          className,
        )}
      >
        {bookkeeper}
      </PopoverTrigger>

      <PopoverContent
        className="rounded-xl border border-gray-200 bg-white shadow-xl dark:border-slate-950 dark:bg-slate-800"
        side={side}
      >
        <div className="max-w-sm space-y-2 p-4">
          <p className="text-sm font-normal text-gray-600 dark:text-slate-300">{children}</p>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default function Bookkeeper({ bookkeeper, className, side }: IBookkeeperProps) {
  if (bookkeeper === "Itaú") {
    return (
      <BookkeeperPopover bookkeeper={bookkeeper} className={className} side={side}>
        Visite a plataforma{" "}
        <a
          href="https://correspondenciasdigitais.com.br/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-blue-600 hover:underline dark:text-blue-400"
        >
          Correspondências Digitais
        </a>{" "}
        do Itaú para acessar os informes de rendimentos mais facilmente. Em caso de dúvidas, ligue na central:{" "}
        <strong>0800 728 0728</strong>.
      </BookkeeperPopover>
    );
  }

  if (bookkeeper === "Bradesco") {
    return (
      <BookkeeperPopover bookkeeper={bookkeeper} className={className} side={side}>
        Se você é correntista, você pode acessar os Informes através do <strong>Internet Banking</strong> na opção:{" "}
        {"Investimentos > Consultas > Ativos Escriturais > Consulta Informe de Rendimentos"}.{" "}
        <strong>Se não for correntista</strong>, acesse os informes através do{" "}
        <a
          href="https://documentosdigitaiscustodia.bradesco/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-blue-600 hover:underline dark:text-blue-400"
        >
          Portal de Documentos Digitais
        </a>
        .
      </BookkeeperPopover>
    );
  }

  return <>{bookkeeper}</>;
}
